export default __webpack_public_path__ + "static/media/ToyotaDisplay-Regular.62a8af8c.eot";